import { validateParams } from '../../utils'

function logForfeitCredit(forfeitAmount, PCLNAnalytics) {
  if (forfeitAmount > 0) {
    PCLNAnalytics.logEvent({
      category: 'mfly-details',
      action: 'Rebook view flight details with forfeit credit',
      label: 'display',
    })
  }
}

function logEvenExchange(cost, forfeitAmount, creditApplied, creditAvailable, PCLNAnalytics) {
  if (cost === 0 && forfeitAmount === 0 && creditApplied === creditAvailable) {
    PCLNAnalytics.logEvent({
      category: 'mfly-details',
      action: 'Rebook view flight details with even exchange',
      label: 'display',
    })
  }
}

function logAddCollect(cost, creditApplied, creditAvailable, PCLNAnalytics) {
  if (cost > 0 && creditApplied === creditAvailable) {
    PCLNAnalytics.logEvent({
      category: 'mfly-details',
      action: 'Rebook view flight details with add-collect',
      label: 'display',
    })
  }
}

export function logRebookLoading({
  PCLNAnalytics,
  isReshopExperience,
  cost,
  forfeitAmount,
  creditApplied,
  creditAvailable,
}) {
  if (!isReshopExperience || !PCLNAnalytics) {
    return
  }
  const isParamsValid = validateParams({
    params: arguments[0],
    paramsTypes: {
      cost: 'number',
      forfeitAmount: 'number',
      creditApplied: 'number',
      creditAvailable: 'number',
      isReshopExperience: 'boolean',
    },
    PCLNAnalytics,
    functionName: 'logRebookWithAddCollect',
    fileName: 'logGaEvent-rebook-details.js',
  })

  if (!isParamsValid) {
    return
  }

  logForfeitCredit(forfeitAmount, PCLNAnalytics)
  logEvenExchange(cost, forfeitAmount, creditApplied, creditAvailable, PCLNAnalytics)
  logAddCollect(cost, creditApplied, creditAvailable, PCLNAnalytics)
}
